// API-related constants
export const API_LIMITS = {
  DEFAULT_PAGE_SIZE: 20,
  MAX_PAGE_SIZE: 100,
  MIN_PAGE_SIZE: 1
};

export const API_TIMEOUTS = {
  DEFAULT: 10000, // 10 seconds
  LONG: 30000 // 30 seconds
};
